import ReactDOM from "react-dom";
import { useState, useEffect } from "react";
import * as S from "./styles";
import { SVG } from "../ui/SVG";
import {
  faArrowRight,
  faCircleExclamation,
  faX,
} from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import CountdownTimer from "../ui/Countdown";
import { useReconnectAliexpress } from "~/hooks/useReconnectAliexpress";

const SESSION_STORAGE_KEY = "reconnectAliexpressBannerDismissed";

export const ReconnectAliexpressBanner = () => {
  const { t } = useTranslation();
  const { handleReconnect, tokenExpiresAt, showReconnectBanner } =
    useReconnectAliexpress();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem(SESSION_STORAGE_KEY) === "true";
    setIsDismissed(dismissed);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
    setIsDismissed(true);
  };

  if (!showReconnectBanner || isDismissed) return null;

  return ReactDOM.createPortal(
    <S.Container>
      <S.CloseButton onClick={handleDismiss} aria-label="Close banner">
        <SVG icon={faX} color="#838383" size="xs" />
      </S.CloseButton>

      <S.SectionContainer>
        <SVG icon={faCircleExclamation} color="#FF7300" />

        <S.Text>{t("aliexpress.reconnect_banner.text")}</S.Text>
      </S.SectionContainer>

      <S.SectionContainer wrap>
        <S.ReconnectButton onClick={() => handleReconnect()}>
          {t("aliexpress.reconnect_banner.button")}
          <SVG icon={faArrowRight} color="#ffffff" />
        </S.ReconnectButton>

        <CountdownTimer
          targetDate={tokenExpiresAt}
          bgColor="transparent"
          numberColor="#191919"
          numberSize="14px"
          lineHeight={1.2}
          textColor="#191919"
          textSize="8px"
          gap={0.6}
          daysKey={t("aliexpress.reconnect_banner.days")}
          hoursKey={t("aliexpress.reconnect_banner.hours")}
          minutesKey={t("aliexpress.reconnect_banner.minutes")}
          showDays
          showHours
          showSeconds={false}
          dots
          dotsColor="#2E2E2E"
          dotsHeight={1.0}
          borderColor="#838383"
          width="37px"
          height="37px"
        />
      </S.SectionContainer>
    </S.Container>,
    document.body
  );
};
